import { render, staticRenderFns } from "./formBank.vue?vue&type=template&id=31f8cd42&scoped=true"
import script from "./formBank.vue?vue&type=script&lang=js"
export * from "./formBank.vue?vue&type=script&lang=js"
import style0 from "./formBank.vue?vue&type=style&index=0&id=31f8cd42&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31f8cd42",
  null
  
)

export default component.exports